import React from "react";
import { IoCloudUploadOutline } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TiTick } from "react-icons/ti";
import Modal from "../../components/common/modal";
import "../../assets/styles/createproduct.css";
import Select from "react-select";
import countryList from "react-select-country-list";
import { useMediaStore } from "../../hooks/media/media.store";
import { useViewIndustryList } from "../../hooks/industries/industrylist";
import { useViewTagsList } from "../../hooks/tags/tags.list";
import toast from "react-hot-toast";

const options = countryList().getData();

const AddMultimedia = () => {
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState();
  const [thumbnailPreview, setThumbnailPreview] = useState();
  const [selectedFileType, setSelectedFileType] = useState("image");
  const { mutate: storeMedia, isLoading } = useMediaStore();
  const { data: industryList, isLoading: isIndustryLoading, error: industryError } = useViewIndustryList();
  const { data: tagsList, isLoading: isTagsLoading, error: tagsError } = useViewTagsList();
  // "http://i.pravatar.cc/500?img=7"

  const readURL = (input) => {
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = function (e) {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(input.files[0]);
    }
  };

  const readThumbnailURL = (input) => {
    if (input.files && input.files[0]) {
      const file = input.files[0];
      setThumbnailFile(file); // Store actual file object
      const reader = new FileReader();
      reader.onload = function (e) {
        setThumbnailPreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const nav = useNavigate();

  const [imageFile, setImageFile] = useState(null); // Single image file
  const [uploadSave, setUploadSave] = useState(false);
  const [upload, setUload] = useState(false);
  const [bulkVideos, setBulkVideos] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [pdfFile, setPdfFile] = useState(null); // Store PDF file object
  const [thumbnailFile, setThumbnailFile] = useState(null); // Store thumbnail file object
  const [fileType, setFileType] = useState("stone");
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(null);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [selectedTag, setSelectedTag] = useState(""); // Store single selected tag ID
  const [selectedIndustry, setSelectedIndustry] = useState(""); // Store selected industry ID
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  const [isFileDragging, setIsFileDragging] = useState(false);

  const getEmbedUrl = (url) => {
    if (
      typeof url === "string" &&
      (url.includes("youtube.com") || url.includes("youtu.be"))
    ) {
      let videoId = "";
      if (url.includes("watch?v=")) {
        videoId = url.split("watch?v=")[1].split("&")[0];
      } else if (url.includes("youtu.be/")) {
        videoId = url.split("youtu.be/")[1].split("?")[0];
      }
      return `https://www.youtube.com/embed/${videoId}`;
    }
    return null;
  };

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setImageFile(file); // Store single file
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files);
    const imageFiles = files.filter((file) => file.type.startsWith("image/"));
    if (imageFiles.length > 0) {
      const file = imageFiles[0]; // Take only first file
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleAddVideoUrl = (e) => {
    e.preventDefault();
    if (videoUrl.trim()) {
      setBulkVideos((prev) => [...prev, videoUrl]);
      setVideoUrl("");
    }
  };

  const handleBulkVideoChange = (e) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      const newVideos = files.map((file) => URL.createObjectURL(file));
      setBulkVideos((prev) => [...prev, ...newVideos]);
    }
  };
  const uploadImages = () => {
    setUload(true);
  };

  const saveData = () => {
    const formData = new FormData();

    try {
      // IMPORTANT: Add 'type' field FIRST before any files
      // Multer's fileFilter needs this to validate file types
      formData.append('type', selectedFileType);

      // Add title and description
      if (title) {
        formData.append('title', title);
      }
      if (description) {
        formData.append('description', description);
      }

      // Add selected industry
      if (selectedIndustry) {
        formData.append('industry', selectedIndustry);
      }

      // Add selected country
      if (value) {
        formData.append('country', value.value || value.label);
      }

      // Add selected tag (single)
      if (selectedTag) {
        formData.append('tags', selectedTag);
      }

      // Now add files AFTER all text fields
      if (selectedFileType === 'image') {
        // For image, append single image file
        if (!imageFile) {
          toast.error('Please upload an image');
          return;
        }
        formData.append('file', imageFile);
      } else if (selectedFileType === 'pdf') {
        // For PDFs, append PDF file and thumbnail with field name "file"
        if (!pdfFile) {
          toast.error('Please upload a PDF file');
          return;
        }
        formData.append('file', pdfFile);
        if (thumbnailFile) {
          formData.append('thumbnail_image', thumbnailFile);
        }
      } else if (selectedFileType === 'video') {
        // For videos, send URLs as field "url"
        if (bulkVideos.length === 0) {
          toast.error('Please add at least one video URL');
          return;
        }
        bulkVideos.forEach((url) => {
          formData.append('url', url);
        });
        // Add thumbnail for video if provided
        if (thumbnailFile) {
          formData.append('thumbnail_image', thumbnailFile);
        }
      }

      // Submit the form
      storeMedia(formData, {
        onSuccess: () => {
          toast.success('Media uploaded successfully!');
          navigate('/mediauploads');
        },
        onError: (error) => {
          toast.error(error?.response?.data?.message || 'Failed to upload media');
        }
      });
    } catch (error) {
      toast.error('An error occurred while uploading');
    }
  };
  const handleRemoveImage = () => {
    setImageFile(null);
    setImagePreview(null);
  };

  const handleVideoClick = (vid, index) => {
    setSelectedVideo(vid);
    setSelectedVideoIndex(index);
    setIsVideoModalOpen(true);
  };

  const closeVideoModal = () => {
    setIsVideoModalOpen(false);
    setSelectedVideo(null);
    setSelectedVideoIndex(null);
  };

  const handleDeleteVideo = (indexToDelete) => {
    setBulkVideos((prev) => prev.filter((_, index) => index !== indexToDelete));
  };

  const handleFileDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsFileDragging(true);
  };

  const handleFileDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsFileDragging(false);
  };

  const [value, setvalue] = useState(null);

  const handleFileDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsFileDragging(false);


    
    const files = Array.from(e.dataTransfer.files);
    const validFiles = files.filter(
      (file) =>
        file.type === "application/pdf" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    );

    if (validFiles.length > 0 && validFiles[0]) {
      const file = validFiles[0]; // Only take the first PDF
      setPdfFile(file); // Store actual file object
      const newFile = {
        id: Date.now(),
        name: file.name,
        size: (file.size / (1024 * 1024)).toFixed(2),
        progress: 100,
        status: "uploaded",
        timeLeft: 0,
      };
      setUploadedFiles([newFile]); // Only one PDF at a time
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setPdfFile(file); // Store actual PDF file object
      const newFile = {
        id: Date.now(),
        name: file.name,
        size: (file.size / (1024 * 1024)).toFixed(2),
        progress: 100,
        status: "uploaded",
        timeLeft: 0,
      };
      setUploadedFiles([newFile]); // Only one PDF at a time
    }
  };

  const handleRemoveFile = (id) => {
    setUploadedFiles((prev) => prev.filter((file) => file.id !== id));
    setPdfFile(null); // Clear the PDF file object when removed
  };

  const handleRetryFile = (id) => {
    setUploadedFiles((prev) =>
      prev.map((file) =>
        file.id === id ? { ...file, status: "uploading", progress: 0 } : file
      )
    );
  };

  // Get industry and tags lists from API
  const industryOptions = industryList?.data || [];
  const tagsOptions = tagsList?.data || [];

  return (
    <>
      <div style={{
        padding: '20px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        {/* Header Section */}
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px',
          marginBottom: '20px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          border: '1px solid #f0f0f0'
        }}>
          <h2 style={{
            fontSize: '24px',
            fontWeight: '500',
            color: '#333',
            marginBottom: '24px'
          }}>Add New Media</h2>

          {/* File Type Selector */}
          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: '#666',
              marginBottom: '12px'
            }}>Select Media Type *</label>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
              gap: '12px'
            }}>
              <button
                type="button"
                onClick={() => setSelectedFileType('image')}
                style={{
                  padding: '16px 24px',
                  border: selectedFileType === 'image' ? '2px solid #004996' : '2px solid #e0e0e0',
                  borderRadius: '8px',
                  background: selectedFileType === 'image' ? '#e3f2fd' : '#fff',
                  color: selectedFileType === 'image' ? '#004996' : '#666',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (selectedFileType !== 'image') {
                    e.currentTarget.style.borderColor = '#004996';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedFileType !== 'image') {
                    e.currentTarget.style.borderColor = '#e0e0e0';
                  }
                }}
              >
                📷 Image
              </button>
              <button
                type="button"
                onClick={() => setSelectedFileType('pdf')}
                style={{
                  padding: '16px 24px',
                  border: selectedFileType === 'pdf' ? '2px solid #004996' : '2px solid #e0e0e0',
                  borderRadius: '8px',
                  background: selectedFileType === 'pdf' ? '#e3f2fd' : '#fff',
                  color: selectedFileType === 'pdf' ? '#004996' : '#666',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (selectedFileType !== 'pdf') {
                    e.currentTarget.style.borderColor = '#004996';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedFileType !== 'pdf') {
                    e.currentTarget.style.borderColor = '#e0e0e0';
                  }
                }}
              >
                📄 PDF
              </button>
              <button
                type="button"
                onClick={() => setSelectedFileType('video')}
                style={{
                  padding: '16px 24px',
                  border: selectedFileType === 'video' ? '2px solid #004996' : '2px solid #e0e0e0',
                  borderRadius: '8px',
                  background: selectedFileType === 'video' ? '#e3f2fd' : '#fff',
                  color: selectedFileType === 'video' ? '#004996' : '#666',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  if (selectedFileType !== 'video') {
                    e.currentTarget.style.borderColor = '#004996';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedFileType !== 'video') {
                    e.currentTarget.style.borderColor = '#e0e0e0';
                  }
                }}
              >
                🎥 Video
              </button>
            </div>
          </div>

          {/* Basic Information */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr auto',
            gap: '24px',
            marginTop: '24px'
          }}>
            <div>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#666',
                marginBottom: '8px'
              }}>Title *</label>
              <input
                type="text"
                placeholder="Enter media title..."
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '400',
                  outline: 'none',
                  transition: 'border-color 0.2s ease'
                }}
                onFocus={(e) => e.currentTarget.style.borderColor = '#004996'}
                onBlur={(e) => e.currentTarget.style.borderColor = '#e0e0e0'}
              />
            </div>
          </div>

          <div style={{ marginTop: '20px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: '#666',
              marginBottom: '8px'
            }}>Description</label>
            <textarea
              placeholder="Enter description..."
              rows="4"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '400',
                outline: 'none',
                resize: 'vertical',
                fontFamily: 'inherit'
              }}
              onFocus={(e) => e.currentTarget.style.borderColor = '#004996'}
              onBlur={(e) => e.currentTarget.style.borderColor = '#e0e0e0'}
            />
          </div>

          {/* Industry and Country Selection */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '20px',
            marginTop: '20px'
          }}>
            <div>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#666',
                marginBottom: '8px'
              }}>Industry</label>
              <select
                value={selectedIndustry}
                onChange={(e) => setSelectedIndustry(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '400',
                  outline: 'none',
                  cursor: 'pointer'
                }}
                onFocus={(e) => e.currentTarget.style.borderColor = '#004996'}
                onBlur={(e) => e.currentTarget.style.borderColor = '#e0e0e0'}
              >
                <option value="">Select Industry</option>
                {isIndustryLoading ? (
                  <option disabled>Loading...</option>
                ) : (
                  industryOptions.map((industry) => (
                    <option key={industry._id} value={industry._id}>
                      {industry.title}
                    </option>
                  ))
                )}
              </select>
            </div>

            <div>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#666',
                marginBottom: '8px'
              }}>Country</label>
              <Select
                options={options}
                value={value}
                onChange={(selectedOption) => setvalue(selectedOption)}
                placeholder="Select Country"
                menuPlacement="bottom"
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderRadius: '8px',
                    border: state.isFocused ? '1px solid #004996' : '1px solid #e0e0e0',
                    fontSize: '14px',
                    minHeight: '46px',
                    boxShadow: 'none',
                    '&:hover': {
                      borderColor: '#004996'
                    }
                  }),
                  menu: (base) => ({
                    ...base,
                    borderRadius: '8px',
                    zIndex: 9999
                  })
                }}
              />
            </div>
          </div>

          {/* Tags Selection */}
          <div style={{ marginTop: '20px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: '#666',
              marginBottom: '8px'
            }}>Tag</label>
            
            <select
              value={selectedTag}
              onChange={(e) => setSelectedTag(e.target.value)}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '400',
                outline: 'none',
                cursor: 'pointer'
              }}
              onFocus={(e) => e.currentTarget.style.borderColor = '#004996'}
              onBlur={(e) => e.currentTarget.style.borderColor = '#e0e0e0'}
            >
              <option value="">Select Tag</option>
              {isTagsLoading ? (
                <option disabled>Loading...</option>
              ) : (
                tagsOptions.map((tag) => (
                  <option key={tag._id} value={tag._id}>
                    {tag.name}
                  </option>
                ))
              )}
            </select>
          </div>
        </div>

        {/* Conditional Upload Section Based on File Type */}
        {selectedFileType === 'image' && (
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '24px',
            marginBottom: '20px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            border: '1px solid #f0f0f0'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '500',
              color: '#333',
              marginBottom: '20px'
            }}>Upload Image</h3>

            <div
              onClick={() => !imagePreview && document.getElementById("imageInput").click()}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              style={{
                border: isDragging ? '2px dashed #004996' : imagePreview ? '2px solid #e0e0e0' : '2px dashed #e0e0e0',
                backgroundColor: isDragging ? '#f0f7ff' : '#fafafa',
                borderRadius: '12px',
                padding: '32px',
                transition: 'all 0.3s ease',
                minHeight: '300px',
                cursor: imagePreview ? 'default' : 'pointer',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {imagePreview ? (
                <div style={{ position: 'relative', width: '100%', maxWidth: '400px' }}>
                  <img
                    src={imagePreview}
                    alt="Preview"
                    style={{
                      width: '100%',
                      height: 'auto',
                      borderRadius: '8px',
                      display: 'block'
                    }}
                  />
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveImage();
                    }}
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: 'rgba(0,0,0,0.7)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '50%',
                      width: '32px',
                      height: '32px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      fontSize: '18px'
                    }}
                  >
                    ×
                  </button>
                </div>
              ) : (
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '48px', marginBottom: '16px' }}>📷</div>
                  <p style={{ fontSize: '16px', fontWeight: '500', color: '#333', marginBottom: '8px' }}>
                    Click or drag image to upload
                  </p>
                  <p style={{ fontSize: '13px', color: '#999' }}>
                    Supported formats: JPG, PNG, JPEG
                  </p>
                </div>
              )}
              <input
                type="file"
                accept="image/*"
                id="imageInput"
                style={{ display: "none" }}
                onChange={handleImageChange}
              />
            </div>
          </div>
        )}

        {selectedFileType === 'pdf' && (
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '24px',
            marginBottom: '20px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            border: '1px solid #f0f0f0'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '500',
              color: '#333',
              marginBottom: '20px'
            }}>Upload PDF Document</h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr auto',
              gap: '24px',
              marginBottom: '24px'
            }}>
              <div
                onClick={() => document.getElementById("fileInput").click()}
                onDragOver={handleFileDragOver}
                onDragLeave={handleFileDragLeave}
                onDrop={handleFileDrop}
                style={{
                  border: isFileDragging ? '2px dashed #004996' : '2px dashed #e0e0e0',
                  backgroundColor: isFileDragging ? '#f0f7ff' : '#fafafa',
                  borderRadius: '12px',
                  padding: '48px 32px',
                  cursor: 'pointer',
                  textAlign: 'center',
                  transition: 'all 0.3s ease'
                }}
              >
                <div style={{ fontSize: '48px', marginBottom: '16px' }}> 📄</div>
                <p style={{ fontSize: '16px', fontWeight: '500', color: '#333', marginBottom: '8px' }}>
                  Click or drag PDF file to upload
                </p>
                <p style={{ fontSize: '13px', color: '#999' }}>
                  Maximum file size: 20MB
                </p>
              </div>

              {/* Thumbnail Upload for PDF */}
              <div style={{ width: '200px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#666',
                  marginBottom: '8px'
                }}>Thumbnail Image</label>
                <div style={{ position: 'relative' }}>
                  <input
                    type="file"
                    id="thumbnailUpload"
                    accept=".png, .jpg, .jpeg"
                    onChange={(e) => readThumbnailURL(e.target)}
                    style={{ display: 'none' }}
                  />
                  <label
                    htmlFor="thumbnailUpload"
                    style={{
                      display: 'block',
                      width: '100%',
                      aspectRatio: '1',
                      border: '2px dashed #e0e0e0',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      cursor: 'pointer',
                      background: thumbnailPreview ? `url(${thumbnailPreview}) center/cover` : '#fafafa',
                      position: 'relative'
                    }}
                  >
                    {!thumbnailPreview && (
                      <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        textAlign: 'center'
                      }}>
                        <div style={{ fontSize: '32px', marginBottom: '4px' }}>+</div>
                        <div style={{ fontSize: '11px', color: '#999' }}>Add</div>
                      </div>
                    )}
                  </label>
                </div>
              </div>
            </div>

            <input
              type="file"
              id="fileInput"
              accept=".pdf"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />

            {uploadedFiles.length > 0 && (
              <div style={{
                borderTop: '1px solid #f0f0f0',
                paddingTop: '20px'
              }}>
                {uploadedFiles.map((file) => (
                  <div key={file.id} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    padding: '16px',
                    background: '#f8f9fa',
                    borderRadius: '8px',
                    marginBottom: '12px'
                  }}>
                    <div style={{ fontSize: '32px' }}>📄</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '4px' }}>
                        {file.name}
                      </div>
                      <div style={{ fontSize: '12px', color: '#666' }}>
                        {file.size} MB
                      </div>
                    </div>
                    <button
                      onClick={() => handleRemoveFile(file.id)}
                      style={{
                        background: '#fff',
                        border: '1px solid #e0e0e0',
                        borderRadius: '6px',
                        padding: '8px 12px',
                        cursor: 'pointer',
                        color: '#e74c3c'
                      }}
                    >
                      <RiDeleteBin5Line size={18} />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {selectedFileType === 'video' && (
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '24px',
            marginBottom: '20px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            border: '1px solid #f0f0f0'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '500',
              color: '#333',
              marginBottom: '20px'
            }}>Add YouTube Video</h3>

            <div style={{ marginBottom: '24px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                fontWeight: '500',
                color: '#666',
                marginBottom: '8px'
              }}>YouTube Video URL *</label>

              <div style={{ width: '200px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#666',
                  marginBottom: '8px'
                }}>Thumbnail Image</label>
                <div style={{ position: 'relative' }}>
                  <input
                    type="file"
                    id="thumbnailUpload"
                    accept=".png, .jpg, .jpeg"
                    onChange={(e) => readThumbnailURL(e.target)}
                    style={{ display: 'none' }}
                  />
                  <label
                    htmlFor="thumbnailUpload"
                    style={{
                      display: 'block',
                      width: '100%',
                      aspectRatio: '1',
                      border: '2px dashed #e0e0e0',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      cursor: 'pointer',
                      background: thumbnailPreview ? `url(${thumbnailPreview}) center/cover` : '#fafafa',
                      position: 'relative'
                    }}
                  >
                    {!thumbnailPreview && (
                      <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        textAlign: 'center'
                      }}>
                        <div style={{ fontSize: '32px', marginBottom: '4px' }}>+</div>
                        <div style={{ fontSize: '11px', color: '#999' }}>Add</div>
                      </div>
                    )}
                  </label>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '12px' }}>
                <input
                  type="text"
                  placeholder="https://www.youtube.com/watch?v=..."
                  value={videoUrl}
                  onChange={(e) => setVideoUrl(e.target.value)}
                  style={{
                    flex: 1,
                    padding: '12px 16px',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    fontSize: '14px',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.currentTarget.style.borderColor = '#004996'}
                  onBlur={(e) => e.currentTarget.style.borderColor = '#e0e0e0'}
                />
                <button
                  onClick={handleAddVideoUrl}
                  style={{
                    padding: '12px 24px',
                    background: 'linear-gradient(135deg, #004996 0%, #0066cc 100%)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Add Video
                </button>
              </div>
            </div>

            {bulkVideos.length > 0 && (
              <div style={{
                borderTop: '1px solid #f0f0f0',
                paddingTop: '20px'
              }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '500',
                  color: '#333',
                  marginBottom: '16px'
                }}>Video Preview</h4>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                  gap: '16px'
                }}>
                  {bulkVideos.map((vid, index) => {
                    const embedUrl = getEmbedUrl(vid);
                    return (
                      <div key={index} style={{
                        position: 'relative',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        border: '1px solid #e0e0e0',
                        background: '#000'
                      }}>
                        {embedUrl ? (
                          <iframe
                            width="100%"
                            height="200"
                            src={embedUrl}
                            title={`video-${index}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                        ) : (
                          <div style={{
                            height: '200px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#666'
                          }}>
                            Invalid URL
                          </div>
                        )}
                        <button
                          onClick={() => handleDeleteVideo(index)}
                          style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            background: 'rgba(0,0,0,0.7)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '8px',
                            cursor: 'pointer'
                          }}
                        >
                          <RiDeleteBin5Line size={16} />
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'flex-end',
          padding: '20px 0'
        }}>
          <button
            type="button"
            onClick={() => navigate('/mediauploads')}
            style={{
              padding: '12px 32px',
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              background: '#fff',
              color: '#666',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f5f5f5';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#fff';
            }}
          >
            Cancel
          </button>
          <button
            onClick={saveData}
            type="button"
            style={{
              padding: '12px 32px',
              border: 'none',
              borderRadius: '8px',
              background: 'linear-gradient(135deg, #004996 0%, #0066cc 100%)',
              color: '#fff',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(0,73,150,0.2)',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,73,150,0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,73,150,0.2)';
            }}
          >
            Save Media
          </button>
        </div>
      </div>

      <Modal
        isOpen={isVideoModalOpen}
        onClose={closeVideoModal}
        className="video-preview-modal"
      >
        <div className="video-modal-wrapper" style={{ position: "relative" }}>
          <button
            className="modal-delete-btn"
            onClick={() => {
              handleDeleteVideo(selectedVideoIndex);
              closeVideoModal();
            }}
            title="Delete video"
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 10,
            }}
          >
            <RiDeleteBin5Line />
          </button>
          {selectedVideo &&
            (() => {
              const embedUrl = getEmbedUrl(selectedVideo);
              return embedUrl ? (
                <iframe
                  width="100%"
                  height="500px"
                  src={embedUrl}
                  title="Video Preview"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <video width="100%" height="500px" controls>
                  <source src={selectedVideo} type="video/mp4" />
                </video>
              );
            })()}
        </div>
      </Modal>
    </>
  );
};

export default AddMultimedia;
